import React from 'react'

const SvgPlayButton = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={50} cy={50} r={50} fill="#FFF" />
      <path fill="currentColor" d="M68.5 49l-28 17.5v-35z" />
    </g>
  </svg>
)

export default SvgPlayButton
